import { Component, inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IotaModalSize, MatDialogRef } from '@iota/iota-ui-components';
import { SmartAssistantResultPage } from 'src/app/shared/constants-and-enums/smart-assistant-types';
import { getCustomerLink } from 'src/app/shared/constants-and-enums/routing';
import { SmartAssistantImportService } from './smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-dialog',
    templateUrl: './smart-assistant-dialog.component.html',
    providers: [SmartAssistantImportService]
})
export class SmartAssistantDialogComponent implements OnDestroy {
    readonly service = inject(SmartAssistantImportService);

    private readonly dialogRef = inject<MatDialogRef<SmartAssistantDialogComponent>>(MatDialogRef);
    private readonly router = inject(Router);

    public modalOptions = {
        size: IotaModalSize.SIZE_7XL
    };

    file: File | null = null;

    ngOnDestroy(): void {
        this.service.cancelUnfinishedImport();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    showResults(route: SmartAssistantResultPage['route']) {
        this.dialogRef.close();
        this.router.navigate([getCustomerLink(this.service.companyId()), route]);
    }

    previousStep() {
        this.service.previousStep();
    }

    nextStep() {
        this.service.nextStep(this.file);
    }

    onFileSelected(file: File | null) {
        this.file = file;
    }

    downloadReport(): void {
        this.service.downloadReport();
    }
}
